var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BE1931",
    d: "M19.598.326c9.613 0 12.243 1.697 12.243 11.311 0 5.506-1.167 8.488-1.167 13.488 0 2.958-4.551 3-8.659 3-4.218 0-9.142.199-11.341-2-6-6-10.545-16.449-2-19C9.129.614 9.984.326 19.598.326z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M26.736 26c2.229 0 4.264.858 4.264 2.903v3.519C31 34.467 28.965 36 26.736 36H15V26h11.736z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M22.341 26c2.454 0 4.659.858 4.659 2.903v3.519C27 34.467 24.795 36 22.341 36h-7.333C12.553 36 11 34.467 11 32.422v-3.519C11 26.858 12.553 26 15.008 26h7.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0041E",
    d: "M4.292 10.948c.715-.575 1.862-1.424 2.383 1.178 1 5 3.794 9.384 3 7-1-3-1-12-1-12-2.437.727-3.806 2.097-4.383 3.822z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M21.674 28c1.105 0 2.326.538 2.326 1.459v3.333c0 .92-1.221 1.208-2.326 1.208h-5C15.57 34 15 33.712 15 32.792v-3.333c0-.921.57-1.459 1.674-1.459h5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxing);
export default __webpack_public_path__ + "static/media/boxing.6e185b1fa8a13bc4f9204f310af3249a.svg";
export { ForwardRef as ReactComponent };